// extracted by mini-css-extract-plugin
export var deliveryRow = "_ns-a";
export var fixedHeight = "_ns-4";
export var freightLogo = "_ns-9";
export var fullWidth = "_ns-3";
export var priceColumn = "_ns-5";
export var radioSelected = "_ns-7";
export var radioUnselected = "_ns-6";
export var selectedOption = "_ns-2";
export var selectedOptionContainer = "_ns-1";
export var selection = "_ns-0";
export var tallSkeletonText = "_ns-8";